import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import customer from "./modules/customer";
import booking from "./modules/booking";
import user from "./modules/user";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    customer,
    booking,
    user,
  },
  getters,
});
